<template>
  <v-card variant="flat" style="height: 100%; width: 100%;overflow-y: auto; overflow-x: auto;" class="px-4 py-4">
    <v-row class="pa-2 customer">
      <v-col cols="6">
        <h2 class="main_title">Process & SOP</h2>
      </v-col>
      <v-col cols="6" style="text-align: end;">
        <v-tooltip v-if="role < 6" text="Add Option" location="bottom">
          <template #activator="{ props }">
            <v-btn v-bind="props" color="#2B2F8E" variant="flat" prepend-icon="mdi-plus" @click="addOption">
              Add Folder
            </v-btn>
          </template>
        </v-tooltip>
      </v-col>

      <!-- <v-col cols="6" style="display: flex; align-items: center;">
          <span class="mr-3">Select an Option:</span>
          <v-combobox
            v-model="selected"
            :items="processDetails"
            item-title="option_name"   
            item-value="option_name"
            label="Select the Option"
            variant="outlined"
            density="comfortable"
            hide-details
            clearable
            class="custom-combobox"
          />
        </v-col> -->

      <!-- <v-col cols="6" style="text-align: end;">
          <v-tooltip text="Delete Option" location="bottom">
            <template #activator="{ props }">
              <v-icon v-bind="props" color="#7B7B7B">mdi-delete-outline</v-icon>
            </template>
          </v-tooltip>
        </v-col> -->
      <v-col cols="12">
        <v-row>
          <v-col cols="3" class="pa-0">
            <div class="tree-container">
              <TreeNode v-for="item in processDetails" :key="item.id" :node="item" :selected-id="selected?.id"
                @select-folder="getselectedFolder" />
            </div>
          </v-col>
          <v-col cols="9">
            <v-row>
              <v-col cols="12">
                <h3 v-if="selected">{{ selected.name }}</h3>
              </v-col>
              <v-col cols="12" v-if="processDetails.length > 0 && selected">
                <UploadImage  v-if="role < 6" @uploaded="upload" :documentUpload="true" :selected="selected" showCard="organisation"></UploadImage>
              </v-col>
               <v-col cols="12" v-else>
                <div class="create mx-5 ga-2 d-flex justify-center align-center" v-if="processDetails.length == 0 && selected == null">
                    <v-icon color="#f9a825">mdi-folder</v-icon>
                    <h3>Create a Folder</h3>
                </div>
                <div class="create mx-5 ga-2 d-flex justify-center align-center" v-else-if="selected == null">
                    <v-icon color="#f9a825">mdi-folder</v-icon>
                    <h3>Select a Folder</h3>
                </div>
              </v-col>
              <v-col cols="12" v-if="selected && selected.documents && selected.documents.length > 0">
                <div class="sop-img" v-if="selected && selected.documents">
                  <div class="imgs" v-for="(item, index) in (selected.documents || [])" :key="index">
                    <div class="img-wrapper">
                      <img :src="item.type == 'image/jpeg' || item.type == 'image/png' || item.type == 'image/svg' ? require('@/assets/image (1).png') :
                        item.type == 'application/pdf' ? require('@/assets/pdf (1).png') :
                          item.type == 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' ||
                            item.type == 'application/vnd.ms-excel' ||
                            item.type == 'text/csv' ? require('@/assets/icons8-excel-480.png') :
                            item.type == 'application/vnd.openxmlformats-officedocument.presentationml.presentation'? require('@/assets/powerpoint.png'):
                            item.type == 'application/msword' ||
                              item.type == 'application/vnd.openxmlformats-officedocument.wordprocessingml.document' ? require('@/assets/word.png') :
                              require('../../assets/camera.png')" alt="Image" :title="item.name" />
                      <v-icon class="eye-icon" @click="view(item)" :title="item.name">mdi-eye</v-icon>
                      <v-icon class="delete-icon"  v-if="role < 6" @click="deleteData(index)" :title="item.name">mdi-delete-outline</v-icon>

                    </div>
                  </div>
                </div>
              </v-col>

              <v-col cols="12" v-else>
                <div class="sop-noCont" v-if="selected && selected.documents">
                  <h3>No Documents Found</h3>
                </div>
              </v-col>
            </v-row>
          </v-col>
        </v-row>
      </v-col>
    </v-row>
  </v-card>
  <v-dialog v-if="dialog" v-model="dialog" width="800">
    <v-card variant="flat" class="px-4 pt-3" style="border-radius: 16px;">
      <v-form ref="form" @submit.prevent="saveOption(this.formData)">
        <v-col cols="12">
          <h3> <span style="color: #2b2f8e;">Add</span> Folder</h3>
        </v-col>
        <v-col cols="12" class="d-flex ga-4">
          <p>Enter the Folder Name<span style="color: red;">*</span></p>
          <TextFieldComponent placeholder="Enter the Folder Name" :rules="[(v) => !!v || 'Folder name is required']" v-model="formData.option_name" />
        </v-col>

        <v-col cols="12">
          <div class="d-flex justify-end ga-2">
            <v-btn color="grey" variant="outlined" @click="onCancel">
              Cancel
            </v-btn>

            <v-btn type="submit" class="save" color="#2B2F8E">
              Save
            </v-btn>
          </div>
        </v-col>
      </v-form>
    </v-card>
  </v-dialog>

  <v-dialog v-if="viewDialog" v-model="viewDialog" width="900">
    <v-card variant="flat" class="px-4 pt-1" style="border-radius: 16px;">
      <div style="display: flex; justify-content: flex-end;">
        <v-icon @click="viewDialog = false" class="cursor-pointer">
          mdi-close
        </v-icon>
      </div>
      <img v-if="img.type == 'image/jpeg' || img.type == 'image/png' || img.type == 'image/svg'" contain :src="img.src"
        alt="Image" />

      <div>
        <iframe v-if="img.type == 'application/pdf'" :src="img.src" width="100%" height="600px"
          style="border: none;"></iframe>
      </div>

      <div v-if="img.type == 'application/msword' || img.type == 'application/vnd.openxmlformats-officedocument.wordprocessingml.document'">
        <div v-if="!img.s3Url" class="text-center pa-8">
          <v-icon size="64" color="orange">mdi-file-word</v-icon>
          <h3 class="mt-4">{{ img.name }}</h3>
          <p class="mt-2">Can't preview Word document in webpage. Kindly Please Download</p>
          <v-btn color="primary" @click="downloadFile" class="mt-4">
            <v-icon left>mdi-download</v-icon>
            Download File
          </v-btn>
        </div>
        <div v-else>
          <iframe 
            width="100%" 
            height="600px"
            style="border: none;"
            :src="`https://view.officeapps.live.com/op/embed.aspx?src=${img.s3Url}`">
          </iframe>
        </div>
      </div>

      <div v-if="img.type == 'application/vnd.openxmlformats-officedocument.presentationml.presentation'">
        <div v-if="!img.s3Url" class="text-center pa-8">
          <v-icon size="64" color="orange">mdi-file-powerpoint</v-icon>
          <h3 class="mt-4">{{ img.name }}</h3>
          <p class="mt-2">Can't preview PowerPoint in webpage. Kindly Please Download</p>
          <v-btn color="primary" @click="downloadFile" class="mt-4">
            <v-icon left>mdi-download</v-icon>
            Download File
          </v-btn>
        </div>
        <div v-else>
          <iframe 
            width="100%" 
            height="600px"
            style="border: none;"
            :src="`https://view.officeapps.live.com/op/embed.aspx?src=${img.s3Url}`">
          </iframe>
        </div>
      </div>

      <div v-if="img.type == 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'">
        <!-- <v-card-title class="bg-primary text-white">
            Excel Preview
            <v-spacer></v-spacer>
          </v-card-title> -->
        <div v-if="!img.s3Url">
          <v-card-text>
            <v-data-table :headers="headers" :items="rows" class="excel-style-table" dense fixed-header height="500px" />
          </v-card-text>
        </div>
        <div v-else>
          <iframe 
            width="100%" 
            height="600px"
            style="border: none;"
            :src="`https://view.officeapps.live.com/op/embed.aspx?src=${img.s3Url}`">
          </iframe>
        </div>
      </div>
    </v-card>
  </v-dialog>
</template>

<script>
// import clientDetailsService from '@/api/service/ClientDetails/ClientDetailsService';
// import ExcelUpload from '../../menus/ExcelUpload.vue';
import TextFieldComponent from '@/components/TextFieldComponent.vue';
import moment from 'moment';
import clientDetailsService from '@/api/service/ClientDetails/ClientDetailsService';
import UploadImage from '@/menus/UploadImage.vue';
import * as XLSX from "xlsx";
import TreeNode from './TreeNode.vue'

export default {
  components: {
    // ExcelUpload,
    TextFieldComponent,
    UploadImage,
    TreeNode
  },
  data() {
    return {
      dialog: false,
      factory: [],
      processDetails: [],
      selected: null,
      user_id: null,
      viewDialog: false,
      img: null,
      excelData: [],
      headers: [],
      rows: [],
      formData: {
        option_name: '',
      },
      role: null,
      pptxUrl: null

      // options: this.processDetails
    }
  },
  created() {
    this.getOrganisation();
    let user = localStorage.getItem('user_details')
    user = JSON.parse(user)
    this.user_id = user.id
    this.role = user.roles.role_type
  },
  methods: {
    onCancel() {
      this.dialog = false
    },



    async view(data) {
      this.viewDialog = true
      this.img = data
      console.log(data, "exex");
      
      // Handle PowerPoint files
      if (this.img.type == 'application/vnd.openxmlformats-officedocument.presentationml.presentation') {
        // Use the original src directly if it's already a public URL
        this.pptxUrl = this.img.src;
        console.log(this.pptxUrl,"urllllllll");
      }
      
      if (this.img.type == 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet') {
        const response = await fetch(this.img.src);
        const buffer = await response.arrayBuffer();
        const workbook = XLSX.read(buffer, { type: "array" });
        const sheet = workbook.SheetNames[0];
        this.excelData = XLSX.utils.sheet_to_json(workbook.Sheets[sheet], { header: 1 });

        this.headers = this.excelData[0].map((h, i) => ({
          title: h || `Column ${i + 1}`,
          key: `col${i}`,
        }));

        this.rows = this.excelData.slice(1).map(row => {
          let obj = {};
          row.forEach((val, i) => {
            obj[`col${i}`] = val;
          });
          return obj;
        });
      }

    },
    async getOrganisation() {
      let $id = this.$route.query.id
      this.organisationData = await clientDetailsService.findOne({ id: $id, collectionName: 'organisation' })
      this.processDetails = this.organisationData && this.organisationData.processSop ? this.organisationData.processSop : this.processDetails
    },

    async save() {
      console.log(this.processDetails, 'ttt')
      this.organisationData.processSop = this.processDetails
      let $data = {
        collectionName: 'organisation',
        data: this.organisationData,
        id: this.$route.query.id
      }
      await clientDetailsService.update($data)
    },
    getselectedFolder($data) {
      console.log($data, 'jfieir')
      this.selected = $data
    },

    async saveOption(data) {
            const validation = await this.$refs.form.validate();
            console.log("vvvvvvvvvv",validation)
            if (!validation.valid) {
                console.log("Form not valid");
            } else {
              const now = moment().format('YYYY-MM-DD HH:mm:ss')
              const newFolder = {
                id: 'f_' + Date.now(),
                type: 'folder',
                name: data.option_name,
                created: now,
                modified: null,
                created_by: this.user_id,
                modified_by: null,
                active: 1,
                deleted: 0,
                deleted_by: null,
                documents: [],
                children: []
              }
              if (this.processDetails && this.processDetails.length > 0) {
                const lastNode = this.getDeepestNode(this.processDetails[this.processDetails.length - 1]);
                if (!lastNode.children) lastNode.children = [];
                lastNode.children.push(newFolder);
              } else {
                this.processDetails.push(newFolder)
              }
              await this.save()
              this.formData.option_name = ''
              this.dialog = false
            }
    },
    getDeepestNode(node) {
      let current = node;
      while (current.children && current.children.length > 0) {
        current = current.children[current.children.length - 1];
      }
      return current;
    },
    async addOption() {
      this.dialog = true
    },

    upload(fileData) {
      if (!this.selected || this.selected.type !== 'folder') {
        alert("Please select a folder to upload documents.");
        return;
      }
      console.log(fileData.type, "fileData");
      const now = moment().format('YYYY-MM-DD HH:mm:ss');
      const newDocument = {
        id: 'doc_' + Date.now(),
        name: fileData.name,
        type: fileData.type,
        src: fileData.src,
        docId: fileData.docId,
        s3Url: fileData.s3Url,
        created: now,
        modified: null,
        created_by: this.user_id,
        modified_by: null,
        active: 1,
        deleted: 0,
        deleted_by: null
      };
      if (!this.selected.documents) this.selected.documents = [];
      this.selected.documents.push(newDocument);
      this.save();
    },
    downloadFile() {
      const link = document.createElement('a');
      link.href = this.pptxUrl;
      link.download = this.img.name;
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    },
    async deleteData(index){
      // console.log(this.selected.documents,"before slice")
      this.selected.documents.splice(index, 1);
      // console.log(this.selected.documents,"after slice")
      this.save()
    }
  }
};
</script>

<style scoped>
.create{
  border: 3px dashed #ccc; 
  border-radius: 10px; 
  height: 200px; 
  padding: 0px !important;
}
.customer {
  display: flex;
  align-items: center;
}

.custom-combobox {
  max-width: 300px;
}

.custom-combobox .v-field {
  border-radius: 6px;
}

.custom-combobox .v-field__append-inner .v-icon {
  color: #000;
}

.sop-img {
  border: 3px dashed #ccc;
  border-radius: 10px;
  padding: 10px !important;
  display: flex;
  gap: 15px;
  overflow-x: auto;
  overflow-y: hidden;
  scrollbar-width: thin;
  max-height: 226px;
  height: 226px
}

.sop-noCont {
  border: 3px dashed #ccc;
  border-radius: 10px;
  padding: 10px !important;
  /* display: flex; */
  /* gap: 15px;
  overflow-x: auto;         
  overflow-y: hidden;        
  scrollbar-width: thin; */
  justify-items: center;
  align-content: center;
  max-height: 226px;
  height: 226px
}

.tree-container {
  min-height: 69vh;
  max-height: 90vh;
  overflow-y: auto;
  border-right: 1px solid #ddd;
  padding-right: 8px;
  padding-left: 4px;
}

.right-content {
  max-height: 90vh;
  overflow-y: auto;
  padding-left: 16px;
}

.children {
  margin-left: 16px;
  white-space: nowrap;
}

.imgs {
  height: 200px;
  min-width: 200px;
  background-color: #E6EDFF;
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 5px;
  position: relative;
}

.img-wrapper {
  position: relative;
  width: 80%;
  height: 80%;
}

.img-wrapper img {
  width: 100%;
  height: 100%;
  object-fit: contain;
  border-radius: 5px;
}

.eye-icon {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  cursor: pointer;
  font-size: 32px;
  color: rgba(0, 0, 0, 0.6);
  background: rgba(255, 255, 255, 0.7);
  border-radius: 50%;
  padding: 5px;
}

.delete-icon{
  position: absolute;
  top: 0%;
  transform: translate(-50%, -50%);
  cursor: pointer;
  font-size: 20px;
  color: rgba(0, 0, 0, 0.6);
  background: rgba(255, 255, 255, 0.7);
  border-radius: 50%;
  padding: 5px;
  padding: 13px;
  color: red;
}

.main_title {
  font-size: 20px;
  font-weight: 600;
}

.excel-style-table {
  border: 1px solid #d0d7de;
  font-family: "Segoe UI", Tahoma, Arial, sans-serif;
  font-size: 14px;
}

:deep(.excel-style-table .v-data-table__th) {
  background-color: #EDEDFF !important;
  color: #000 !important;
  font-weight: bold !important;
  text-align: center !important;
  border: 1px solid #d0d7de !important;
  padding: 8px !important;
}

:deep(.excel-style-table .v-data-table__td) {
  border: 1px solid #d0d7de !important;
  padding: 6px 10px !important;
  vertical-align: middle;
  white-space: nowrap;
}

:deep(.excel-style-table .v-data-table__tr:nth-child(even)) {
  background-color: #f9f9f9 !important;
}

:deep(.excel-style-table .v-data-table__tr:nth-child(odd)) {
  background-color: #ffffff !important;
}
</style>